"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const lodash_1 = __importDefault(require("lodash"));
const Event_1 = __importDefault(require("./Event"));
const Api_1 = __importDefault(require("./Api"));
const chalk_1 = __importDefault(require("chalk"));
const numeral_1 = __importDefault(require("numeral"));
const getDecimalPosition = (value) => (value.toString().split('.')[1] || []).length;
class DexkoPlugins {
    install(vue) {
        vue.prototype.$ev = Event_1.default;
        vue.prototype._ = lodash_1.default;
        window['_'] = lodash_1.default;
        vue.prototype.moment = moment_1.default;
        vue.prototype.$api = Api_1.default;
        vue.prototype.chalk = chalk_1.default;
        const formatNumber = (value = 0, callUnit) => {
            const _callUnit = (typeof callUnit === 'number' ? callUnit : callUnit.callUnit) || (callUnit.baseCoinCode.toUpperCase() === 'KRW' ? 0 : 8);
            const decimalPos = _callUnit < 1 && _callUnit !== 0 ? getDecimalPosition(_callUnit) : 0;
            const format = `0,0[.]${lodash_1.default.repeat('0', decimalPos)}`;
            return (0, numeral_1.default)(value).format(format);
        };
        vue.prototype.formatNumber = formatNumber;
        return vue;
    }
}
const dexkoPlugin = new DexkoPlugins();
exports.default = dexkoPlugin;
